import React from 'react';

const TemperatureIcon = ({
  width = 31,
  height = 31,
  fill = 'none',
  className,
}) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox='0 0 62 62' className={className}>
      <g fill={fill} fillRule='evenodd'>
        <path fill='#FFF' d='M33.885 33.59v3.079A5.178 5.178 0 0 1 36 40.859C36 43.699 33.761 46 31 46s-5-2.302-5-5.141c0-1.73.839-3.257 2.115-4.19V17.967C28.115 16.328 29.407 15 31 15c1.593 0 2.885 1.328 2.885 2.966v2.14H31v1.65h2.885v2.293H31V25.7h2.885v2.294H31v1.651h2.885v2.293H31v1.651h2.885z'
        />
        <circle cx='31' cy='31' r='30.5' stroke='#FFF' />
      </g>
    </svg>
  );
};

export default TemperatureIcon;


// WEBPACK FOOTER //
// ./src/app/intro/components/TemperatureIcon/TemperatureIcon.js